import { render, staticRenderFns } from "./PanelGroupShipper.vue?vue&type=template&id=647a8662&scoped=true"
import script from "./PanelGroupShipper.vue?vue&type=script&lang=js"
export * from "./PanelGroupShipper.vue?vue&type=script&lang=js"
import style0 from "./PanelGroupShipper.vue?vue&type=style&index=0&id=647a8662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647a8662",
  null
  
)

export default component.exports